import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Divider, Menu, Modal } from 'antd';
import { CaretDownOutlined, ExclamationCircleOutlined, FileOutlined, InfoCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import { NavLink, useHistory } from 'react-router-dom';
import { UserContext } from '../contexts';
import SubMenu from 'antd/lib/menu/SubMenu';
import { AboutPage } from '../about';

export function UserMenu(props: { headerSize: any }) {
  const { user } = useContext(UserContext);
  const history = useHistory();

  const [nameInitials, setNameInitials] = useState<string>();
  const [showAboutModal, setShowAboutModal] = useState(false);

  useEffect(() => {
    if (!user) {
      setNameInitials(undefined);
    } else {
      const nameArray = user.fullName.split(' ');
      if (nameArray.length > 1) {
        const surname = nameArray[nameArray.length - 1];
        setNameInitials(nameArray[0].substr(0, 1) + surname.substr(0, 1));
      } else {
        setNameInitials(nameArray[0].substr(0, 1));
      }
    }
  }, [user]);

  const onMenuClick = (e: any) => {
    if (e.key === '/about') {
      setShowAboutModal(true);
    } else if (e.key === '/logout') {
      confirmExit();
    }
  };

  const confirmExit = () => {
    const onOk = () => history.push('/logout');
    Modal.confirm({
      title: 'Çıkış yap',
      icon: <ExclamationCircleOutlined />,
      content: 'Uygulamadan çıkış yapmak istediğinize emin misiniz?',
      okText: 'Evet',
      cancelText: 'Vazgeç',
      onOk: onOk,
    });
  };

  if (!user) {
    return null;
  }

  return (
    <>
      <Menu
        theme="dark"
        mode="horizontal"
        style={{ backgroundColor: '#294D78', textAlign: 'right' }}
        selectable={false}
        onClick={(e: any) => onMenuClick(e)}
      >
        <SubMenu
          icon={<Avatar style={{ backgroundColor: '#87d068', marginRight: '0.25rem' }}>{nameInitials}</Avatar>}
          title={
            <span style={{ color: '#ffffffa5' }}>
              {!props.headerSize?.width || props.headerSize?.width >= 1250 ? user?.fullName : null} <CaretDownOutlined />
            </span>
          }
        >
          <Menu.Item key="/about" style={{ marginBottom: 0 }}>
            <InfoCircleOutlined /> Hakkında
          </Menu.Item>
          <Menu.Item key="/documentation" style={{ marginBottom: 0 }}>
            <NavLink to="/documentation/help">
              <FileOutlined /> Dokümantasyon
            </NavLink>
          </Menu.Item>
          <Divider style={{ margin: 0 }} />
          <Menu.Item key="/logout" style={{ marginBottom: 0 }}>
            <LogoutOutlined /> Çıkış yap
          </Menu.Item>
        </SubMenu>
      </Menu>
      <Modal title="Hakkında" visible={showAboutModal} footer={null} onCancel={() => setShowAboutModal(false)} destroyOnClose width={600}>
        <AboutPage />
      </Modal>
    </>
  );
}
